import React, { useEffect, useState } from 'react';
import { SelectMultiple } from 'tea-component';
import { useIntl } from 'umi';

export default function Metrics({
  onChange,
  key,
  defaultValue,
  defaultParams: { placeholder = '', options, ...restParams },
}: any) {
  const { formatMessage } = useIntl();
  if (defaultValue === undefined) {
    defaultValue = options?.map((item: any) => item.value);
  }
  const [value, setValue] = useState<string[]>(defaultValue || []);

  useEffect(() => {
    setValue(defaultValue || []);
  }, [defaultValue]);

  return (
    <SelectMultiple
      appearance="button"
      value={value}
      staging={false}
      size="m"
      matchButtonWidth
      allOption={{ text: formatMessage({ id: 'All' }), value: 'all' }}
      placeholder={placeholder}
      onChange={(value) => {
        setValue(value);
        onChange?.(key, value);
      }}
      button={(selectInfo) => {
        const selectLen = selectInfo.length;
        const optionLen = options.length;
        const isAll = selectLen === optionLen;

        return (
          <div className="select-button">
            <span className="select-button-text">
              {formatMessage({ id: 'Metrics' })}:{' '}
            </span>
            <span className="select-button-value">
              {isAll
                ? formatMessage({ id: 'All' })
                : `${selectLen}/${optionLen}`}
            </span>
          </div>
        );
      }}
      options={options}
      {...restParams}
    />
  );
}
